// extracted by mini-css-extract-plugin
module.exports = {"container":"Backdrop_container__2VIrf"};